package fr.frux.core.common.di

import fr.frux.core.common.prefs.AppPreferences
import fr.frux.core.common.prefs.createAppPreferences
import dev.zacsweers.metro.ContributesTo
import dev.zacsweers.metro.Provides
import dev.zacsweers.metro.SingleIn

/**
 * Metro DI module providing AppPreferences.
 */
@ContributesTo(AppScope::class)
interface AppPreferencesModule {

    companion object {
        @Provides
        @SingleIn(AppScope::class)
        fun provideAppPreferences(): AppPreferences {
            return createAppPreferences()
        }
    }
}
